<div class="common-dropdown-container">
  <span-tooltip class="common-table-cell__title-text-label"
    [text]="filterByOrder.label"></span-tooltip>
  <button class="common-button__filter-order-button"
    [ngClass]="{'common-button__filter-order-button--active': filterOrder === item?.filterOrder}"
    (click)="orderColumn()">
      <i class="common-icon__md"
        [ngClass]="filterOrder === item?.filterOrder && !order?'lf-icon-arrow-up':'lf-icon-arrow-down'"></i>
  </button>
</div>

